// Mock data for JYA Battery Rental Landing Page

export const heroData = {
  title: "Toujours Connecté, Toujours Chargé",
  subtitle: "Louez une batterie externe en quelques secondes dans nos bornes intelligentes",
  cta: "Trouver une borne",
  ctaPartner: "Devenir partenaire",
  heroImage: "https://images.unsplash.com/photo-1770417999831-1c070eb628e6"
};

export const benefitsData = [
  {
    id: 1,
    icon: "zap",
    title: "Charge Ultra-Rapide",
    description: "100% de batterie en seulement 20 minutes grâce à la charge rapide 22,5W. Repartez vite et restez connecté."
  },
  {
    id: 2,
    icon: "euro",
    title: "Prix Attractif",
    description: "Seulement 1,99€ la location. Ne restez plus jamais à court de batterie."
  },
  {
    id: 3,
    icon: "map-pin",
    title: "Partout avec Vous",
    description: "Nos bornes sont disponibles dans les centres commerciaux, hôpitaux, cafés, cinémas et universités."
  },
  {
    id: 4,
    icon: "shield-check",
    title: "Sécurisé et Fiable",
    description: "Batteries certifiées et contrôlées régulièrement pour votre sécurité."
  }
];

export const howItWorksData = [
  {
    step: 1,
    icon: "scan",
    title: "Scannez le QR Code",
    description: "Approchez-vous d'une borne JYA et scannez le QR code avec votre smartphone."
  },
  {
    step: 2,
    icon: "credit-card",
    title: "Payez 1,99€",
    description: "Effectuez le paiement sécurisé directement depuis votre mobile."
  },
  {
    step: 3,
    icon: "battery-charging",
    title: "Rechargez et Retournez",
    description: "Prenez la batterie, rechargez votre téléphone à 100% en 20 minutes et retournez-la dans n'importe quelle borne JYA grâce à notre application."
  }
];

export const locationsData = [
  {
    id: 1,
    type: "Centres Commerciaux",
    icon: "shopping-bag",
    description: "Faites vos achats sans craindre de manquer de batterie",
    image: "https://images.pexels.com/photos/374894/pexels-photo-374894.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    type: "Hôpitaux",
    icon: "heart-pulse",
    description: "Restez joignable pendant vos visites",
    image: "https://images.unsplash.com/photo-1481437156560-3205f6a55735"
  },
  {
    id: 3,
    type: "Cafés & Bars",
    icon: "coffee",
    description: "Profitez de votre moment détente connecté",
    image: "https://images.unsplash.com/photo-1521017432531-fbd92d768814"
  },
  {
    id: 4,
    type: "Cinémas",
    icon: "film",
    description: "Ne manquez aucun moment avant et après la séance",
    image: "https://images.unsplash.com/photo-1481437156560-3205f6a55735"
  },
  {
    id: 5,
    type: "Universités",
    icon: "graduation-cap",
    description: "Étudiez et restez connecté toute la journée",
    image: "https://images.pexels.com/photos/1046125/pexels-photo-1046125.jpeg"
  },
  {
    id: 6,
    type: "Espaces Publics",
    icon: "building-2",
    description: "Partout où vous en avez besoin",
    image: "https://images.unsplash.com/photo-1569096651661-820d0de8b4ab"
  }
];

export const pricingData = {
  price: "1,99€",
  duration: "par location",
  features: [
    "Location illimitée dans le temps",
    "Retour dans n'importe quelle borne",
    "Batteries haute capacité (10 000mAh)",
    "Compatible tous smartphones",
    "Câbles intégrés (USB-C, Lightning, Micro-USB)"
  ]
};

export const partnerData = {
  title: "Devenez Partenaire JYA",
  subtitle: "Installez une borne dans votre établissement et gagnez 30% du chiffre d'affaires de votre secteur",
  benefits: [
    {
      icon: "trending-up",
      title: "30% de Commission",
      description: "Recevez 30% du chiffre d'affaires généré par les bornes installées dans votre secteur"
    },
    {
      icon: "users",
      title: "Attirez plus de Clients",
      description: "Offrez un service pratique qui fait revenir vos visiteurs"
    },
    {
      icon: "wrench",
      title: "Installation Gratuite",
      description: "Nous nous occupons de tout : installation, maintenance et gestion. Possibilité d'installer plusieurs bornes selon vos besoins"
    },
    {
      icon: "bar-chart-3",
      title: "Suivi en Temps Réel",
      description: "Accédez à vos statistiques et revenus via notre tableau de bord"
    }
  ]
};

export const faqData = [
  {
    question: "Combien de temps faut-il pour recharger mon téléphone ?",
    answer: "Avec nos batteries haute capacité et la charge rapide 22,5W, votre téléphone peut atteindre 100% de charge en environ 20 minutes seulement ! Vous repartez rapidement avec un téléphone complètement chargé."
  },
  {
    question: "Comment louer une batterie ?",
    answer: "Il suffit de scanner le QR code sur la borne avec votre smartphone, de payer 1,99€, et la batterie se libère automatiquement. Vous pouvez ensuite l'utiliser aussi longtemps que nécessaire."
  },
  {
    question: "Où puis-je retourner la batterie ?",
    answer: "Vous pouvez retourner la batterie dans n'importe quelle borne JYA, peu importe où vous l'avez louée. Notre application mobile vous montre sur une carte interactive tous les lieux équipés de bornes JYA pour faciliter vos retours."
  },
  {
    question: "Que se passe-t-il si je perds ou endommage la batterie ?",
    answer: "En cas de perte ou de dommage, des frais supplémentaires peuvent s'appliquer. Nous vous conseillons de prendre soin de la batterie et de la retourner dès que possible."
  },
  {
    question: "Les batteries sont-elles compatibles avec mon téléphone ?",
    answer: "Oui ! Nos batteries sont équipées de câbles intégrés compatibles avec tous les smartphones : USB-C, Lightning (iPhone) et Micro-USB."
  },
  {
    question: "Comment devenir partenaire ?",
    answer: "Remplissez le formulaire de partenariat sur cette page. Notre équipe vous contactera dans les 48h pour discuter des modalités d'installation d'une borne dans votre établissement."
  },
  {
    question: "Quelles sont les options de bornes disponibles ?",
    answer: "Nous proposons deux modèles : la grande borne avec 24 batteries et la petite borne avec 16 batteries. En tant que partenaire, vous pouvez installer autant de bornes que nécessaire selon l'affluence de votre établissement."
  }
];

export const stationImage = "https://customer-assets.emergentagent.com/job_battery-hub-14/artifacts/arrl2pyw_image.png";

export const newStationImage = "https://customer-assets.emergentagent.com/job_battery-hub-14/artifacts/3owwjp36_image.png";

export const batteryImage = "https://customer-assets.emergentagent.com/job_battery-hub-14/artifacts/4oihxfzd_image.png";
